import { logger } from "./log";

export default function(showLogs, consoles) {
  for (const x in consoles) {
    this[x] = logger(showLogs && consoles[x]);
  }
}
